// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Vw","carousel__wrapper_on_sides":"Ww","arrows_wrapper":"Xw","arrows_wrapper_right":"Yw","arrows_wrapper_vertical":"Zw","arrows_wrapper_on_sides":"ax","arrow_button":"bx","carousel_arrow_left":"cx","carousel_arrow_left_on_side":"ex","carousel_arrow_right_on_side":"fx","carousel_arrow":"gx","arrows_wrapper_rounded":"hx","carousel__fullWidth":"ix"};
    if(module.hot) {
      // 1713211519702
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  